<div class="agpr-automaticAdditionalSettings">
    <span class="agpr-automaticAdditionalSettings-label"> {{ 'Mention.customization.insights' | localize }} </span>
    <div [ngClass]="{
        'agpr-automaticAdditionalSettings-spacing': !showInsights,
        'agpr-automaticAdditionalSettings-spacingSmall': showInsights,
    }">
        <agpr-checkbox
            [id]="id + '_automaticAutoInsight_showInsights'"
            label="Mention.customization.showInsights"
            infoCircleTooltip="Briefings.blockType.autoGeninsights.showInsights.tooltip"
            [binary]="true"
            [(ngModel)]="showInsights"
            (ngModelChange)="showInsightChange()"
        ></agpr-checkbox>
    </div>

    @if (showInsights) {
        <div class="agpr-automaticAdditionalSettings-indent">
            <div class="agpr-automaticAdditionalSettings-spacing">
                <agpr-checkbox
                    [id]="id + '_automaticAutoInsightDialog_generateAutomatically'"
                    label="Briefings.blockType.autoGeninsights.generateAutomatically"
                    infoCircleTooltip="Briefings.blockType.autoGeninsights.generateAutomatically.tooltip"
                    [binary]="true"
                    [(ngModel)]="confirmGenerate"
                    (ngModelChange)="setInsightsDefault()"
                ></agpr-checkbox>
            </div>

            @if (confirmGenerate) {
                <div class="agpr-automaticAdditionalSettings-indent">
                    <div class="agpr-automaticAdditionalSettings-spacing">
                        <agpr-dropdown
                            label="Briefings.blockType.autoGeninsights.insightType"
                            [options]="mentionInsightTypesOptions"
                            [(ngModel)]="selectedMentionInsightType"
                            (ngModelChange)="updateValue()"
                        ></agpr-dropdown>
                    </div>

                    @if (selectedMentionInsightType?.value === mentionInsightTypes.CONTEXTUAL_ANALYSIS || selectedMentionInsightType?.value === mentionInsightTypes.SENTIMENT_OPINION) {
                        <div class="agpr-automaticAdditionalSettings-spacing">
                            <div class="agpr-mentionWorkbenchDialog-insights-main-promptKeywords">
                                <agpr-radio
                                    [id]="id + '_insight_savedMentionKeywordContextRadio'"
                                    label="Mention.workbench.insights.prompt.savedKeywords"
                                    hiddenLabel="Mention.workbench.insights.prompt.savedKeywords"
                                    [(ngModel)]="isMentionKeywords"
                                    name="automaticAdditionalSettings-promptKeywords"
                                    (ngModelChange)="updateValue()"
                                    [value]="true"
                                ></agpr-radio>
                                <agpr-radio
                                    [id]="id + '_insight_manualKeywordsRadio'"
                                    label="Mention.workbench.insights.prompt.manualKeywords"
                                    hiddenLabel="Mention.workbench.insights.prompt.manualKeywords"
                                    [(ngModel)]="isMentionKeywords"
                                    name="automaticAdditionalSettings-promptKeywords"
                                    [value]="false"
                                    (ngModelChange)="updateValue()"
                                ></agpr-radio>
                                @if (!isMentionKeywords) {
                                    <div class="agpr-automaticAdditionalSettings-indent">
                                        <agpr-text-input-chips
                                            [id]="id + '_insight_manualKeywords'"
                                            [placeholder]="'Mention.workbench.insights.prompt.enterKeywords'"
                                            [(ngModel)]="manualKeywords"
                                            (ngModelChange)="updateValue()"
                                        ></agpr-text-input-chips>
                                    </div>
                                }
                            </div>
                        </div>
                    }

                    <div class="agpr-automaticAdditionalSettings-spacing">
                        @if (selectedMentionInsightType?.value !== mentionInsightTypes.QUOTES && selectedMentionInsightType?.value !== mentionInsightTypes.CUSTOM) {
                            <agpr-dropdown
                                label="Common.dialog.aiHelper.language"
                                [options]="promptLanguageOptions"
                                [(ngModel)]="selectedPromptLanguageOption"
                                [infoCircleTooltip]="'Common.dialog.aiHelper.languageTooltip'"
                                (ngModelChange)="updateValue()"
                            ></agpr-dropdown>
                        }
                    </div>

                    @if (selectedMentionInsightType?.value === mentionInsightTypes.CUSTOM) {
                        <div class="agpr-automaticAdditionalSettings-spacing">
                            <agpr-dropdown
                                label="Briefings.analysis.customAnalysisType"
                                [placeholder]="'Briefings.analysis.customAnalysisType.placeholder'"
                                [options]="customInsightsOptions"
                                [(ngModel)]="selectedCustomInsightOption"
                                (ngModelChange)="selectCustomPrompt($event)"
                            ></agpr-dropdown>
                        </div>
                    @if (!selectedCustomInsightOption?.value?.id && block?.errors?.includes('Briefings.analysis.errors.customPromptIsRequired')) {
                            <agpr-form-message>
                                {{ 'Briefings.analysis.errors.customPromptIsRequired' | localize }}
                            </agpr-form-message>
                        }
                        @if (selectedCustomInsightOption) {
                            <div class="agpr-automaticAdditionalSettings-padding">
                                <agpr-text-input
                                    [id]="id + '_custom_name'"
                                    [maxLength]="64"
                                    [label]="'Mention.workbench.insights.prompt.custom.name'"
                                    [placeholder]="'Mention.workbench.insights.prompt.custom.name.placeholder'"
                                    [required]="true"
                                    [(ngModel)]="selectedCustomInsightOption.value.name"
                                    (ngModelChange)="customInsightFieldChanged()"
                                ></agpr-text-input>
                            </div>
                            <div class="agpr-automaticAdditionalSettings-padding">
                                <agpr-textarea-input
                                    [id]="id + '_custom_prompt'"
                                    [label]="'Mention.workbench.insights.prompt.custom.prompt'"
                                    [required]="true"
                                    [placeholder]="'Mention.workbench.insights.prompt.custom.prompt.tooltip'"
                                    ariaLabel="Mention.workbench.insights.prompt.custom.prompt.tooltip"
                                    [(ngModel)]="selectedCustomInsightOption.value.prompt"
                                    [rows]="7"
                                    [icon]="'fa-kit-duotone fa-agpr-ai-generic'"
                                    (ngModelChange)="customInsightFieldChanged()"
                                ></agpr-textarea-input>
                            </div>
                            <div class="agpr-automaticAdditionalSettings-customActions">
                                <div class="agpr-automaticAdditionalSettings-spacer"></div>
                                <agpr-button
                                    [id]="id + '_insight_saveCustomInsight'"
                                    label="Briefings.analysis.customAnalysis.save"
                                    [style]="buttonTypes.tertiary"
                                    [disabled]="!allowCustomInsightSave"
                                    [agprTooltip]="saveCustomInsightTooltip"
                                    (click)="saveCustomInsight()"
                                ></agpr-button>
                                @if (selectedCustomInsightOption.value?.id) {
                                    <agpr-button
                                        label="Briefings.analysis.customAnalysis.saveAs"
                                        [style]="buttonTypes.tertiary"
                                        [disabled]="!allowCustomInsightSave"
                                        [agprTooltip]="'Briefings.analysis.customAnalysis.saveAs.tooltip'"
                                        [id]="id + '_insight_saveAsCustomInsight'"
                                        (click)="openSaveAsInsightDialog()"
                                    ></agpr-button>
                                }
                            </div>
                        }
                    }


                    @if (isSavedSource) {
                        <agpr-checkbox
                            [id]="id + '_automaticAutoInsightDialog_setAsPreferred'"
                            label="Briefings.blockType.autoGeninsights.setAsPreferred"
                            [binary]="true"
                            [(ngModel)]="setPreferred"
                            (ngModelChange)="updateValue()"
                        ></agpr-checkbox>

                        <agpr-checkbox
                            [id]="id + '_automaticAutoInsightDialog_allSavedMentions'"
                            label="Briefings.blockType.autoGeninsights.withoutInsights"
                            [binary]="true"
                            [(ngModel)]="withoutInsightsOnly"
                            (ngModelChange)="updateValue()"
                        ></agpr-checkbox>
                    }
                </div>
            }
        </div>
    }

    @if (hasPrecisionClipPermission) {
        <span class="agpr-automaticAdditionalSettings-label"> {{ 'Monitor.precisionClipping' | localize }} </span>
        <div class="agpr-automaticAdditionalSettings-spacing">
            <agpr-checkbox
                [id]="id + '_automatic_precision_clip'"
                class="precisionClip-checkbox"
                label="Mention.customization.precisionClip"
                infoCircleTooltip="Mention.customization.precisionClip.tooltip"
                tooltipPosition="left"
                [binary]="true"
                [(ngModel)]="generatePrecisionClip"
                (ngModelChange)="setPrecisionDefault()"
            ></agpr-checkbox>

            @if (generatePrecisionClip) {
                <div class="precisionClip">
                    <div class="precisionClip-group">
                        <agpr-radio
                            [id]="id + '_savedMentionKeywordOption'"
                            class="precisionClip-radio"
                            [value]="keywordSelectionEnum.SAVED_MENTION"
                            [(ngModel)]="keywordSelection"
                            (ngModelChange)="updateValue()"
                            label="Monitor.precisionClip.keyword.option.mention"
                            hiddenLabel="Monitor.precisionClip.keyword.option.mention"
                        ></agpr-radio>

                        @if (keywordSelection === keywordSelectionEnum.SAVED_MENTION) {
                            <agpr-text-input-chips
                                [id]="id + '_fallbackKeywords'"
                                class="precisionClip-indent"
                                placeholder="Monitor.precisionClip.setup.fallback.keyword.placeholder"
                                header="Monitor.precisionClip.setup.fallback.keyword"
                                tooltip="Monitor.precisionClip.setup.fallback.keyword.tooltip"
                                [(ngModel)]="fallbackKeywords"
                                (ngModelChange)="updateValue()"
                            ></agpr-text-input-chips>
                        }

                        <div class="precisionClip-group">
                            <agpr-radio
                                [id]="id + '_manualKeywordOption'"
                                class="precisionClip-radio"
                                [value]="keywordSelectionEnum.MANUAL"
                                label="Monitor.precisionClip.setup.keyword.option.manual"
                                hiddenLabel="Monitor.precisionClip.setup.keyword.option.manual"
                                [(ngModel)]="keywordSelection"
                                (ngModelChange)="updateValue()"
                            ></agpr-radio>

                            @if (keywordSelection === keywordSelectionEnum.MANUAL) {
                                <agpr-text-input-chips
                                    [id]="id + '_manualKeywords'"
                                    class="precisionClip-indent"
                                    placeholder="Mention.workbench.insights.prompt.enterKeywords"
                                    [(ngModel)]="precisionManualKeywords"
                                    (ngModelChange)="updateValue()"
                                ></agpr-text-input-chips>
                                @if (block?.errors?.includes('Briefings.analysis.errors.noManualKeywords')) {
                                    <agpr-form-message>
                                        {{ 'Briefings.analysis.errors.noManualKeywords' | localize }}
                                    </agpr-form-message>
                                }
                            }
                        </div>
                    </div>

                    <div>
                        <h6 class="precisionClip-heading">
                            {{ 'Monitor.precisionClip.clip.insights' | localize }}
                        </h6>

                        <agpr-checkbox
                            [id]="id + '_insightsCheckbox'"
                            label="Monitor.precisionClip.setup.insights.label"
                            [binary]="true"
                            [(ngModel)]="insightsEnabled"
                            (ngModelChange)="updateValue()"
                        ></agpr-checkbox>
                    </div>

                    <agpr-panel
                        [id]="id + '_expertPanel'"
                        class="precisionClip-panel"
                        header="Monitor.precisionClip.setup.expertSettings"
                        [collapsed]="true"
                        [showCustomHeader]="false"
                        [noBorder]="true"
                        [spaceBetweenExpand]="false"
                    >
                        <div class="precisionClip-panelRow">
                            <agpr-number-input
                                [id]="id + '_extendStartTime'"
                                label='Monitor.precisionClip.setup.extend.start'
                                [(ngModel)]="extendStartTime"
                                (ngModelChange)="updateValue()"
                                [min]="0"
                                [max]="60"
                            ></agpr-number-input>

                            <agpr-number-input
                                [id]="id + '_extendEndTime'"
                                label='Monitor.precisionClip.setup.extend.end'
                                [(ngModel)]="extendedEndTime"
                                (ngModelChange)="updateValue()"
                                [min]="0"
                                [max]="60"
                            ></agpr-number-input>
                        </div>
                    </agpr-panel>
                </div>

                <agpr-message [severity]="messageSeverityEnum.warning">
                    {{ 'Monitor.precisionClip.setup.warning' | localize }}
                </agpr-message>
            }
        </div>
    }
</div>
